
import React, { useState } from 'react';
import { useSignalData } from '../context/SignalContext';
import { TransactionStatus } from '../types';
import { ArrowDownRight, ArrowUpRight, DollarSign, Wallet, History, Search } from 'lucide-react';

export const AdminFinance: React.FC = () => {
    const { transactions, payouts } = useSignalData();
    const [searchTerm, setSearchTerm] = useState('');

    const totalIn = transactions.filter(t => t.status === TransactionStatus.APPROVED || t.status === TransactionStatus.PAID).reduce((s, t) => s + t.amount, 0);
    const totalOut = payouts.filter(p => p.status === TransactionStatus.PAID).reduce((s, p) => s + p.amount, 0);

    const filteredTxns = transactions.filter(t => t.customerName.toLowerCase().includes(searchTerm.toLowerCase()));
    const filteredPayouts = payouts.filter(p => p.affiliateName.toLowerCase().includes(searchTerm.toLowerCase()));

    return (
        <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-white p-6 rounded-xl border border-slate-100 shadow-sm">
                    <div className="flex items-center gap-3 mb-2">
                        <div className="w-10 h-10 bg-emerald-100 text-emerald-600 rounded-lg flex items-center justify-center"><ArrowDownRight /></div>
                        <span className="text-sm font-bold text-slate-500 uppercase">Tổng tiền vào</span>
                    </div>
                    <h2 className="text-3xl font-black text-slate-800">${totalIn.toLocaleString()}</h2>
                    <p className="text-xs text-slate-400 mt-2">Doanh số Private</p>
                </div>
                <div className="bg-white p-6 rounded-xl border border-slate-100 shadow-sm">
                    <div className="flex items-center gap-3 mb-2">
                        <div className="w-10 h-10 bg-red-100 text-red-600 rounded-lg flex items-center justify-center"><ArrowUpRight /></div>
                        <span className="text-sm font-bold text-slate-500 uppercase">Tổng tiền ra</span>
                    </div>
                    <h2 className="text-3xl font-black text-slate-800">${totalOut.toLocaleString()}</h2>
                    <p className="text-xs text-slate-400 mt-2">Đã thanh toán cho Affiliate</p>
                </div>
                <div className="bg-slate-900 p-6 rounded-xl shadow-lg text-white">
                    <div className="flex items-center gap-3 mb-2">
                        <div className="w-10 h-10 bg-brand-600 rounded-lg flex items-center justify-center text-white"><DollarSign /></div>
                        <span className="text-sm font-bold text-slate-300 uppercase">Lợi nhuận gộp</span>
                    </div>
                    <h2 className="text-3xl font-black">${(totalIn - totalOut).toLocaleString()}</h2>
                    <p className="text-xs text-slate-500 mt-2">Chưa trừ các chi phí vận hành</p>
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <div className="bg-white rounded-xl shadow-sm border border-slate-200">
                    <div className="p-4 border-b border-slate-100 flex justify-between items-center">
                        <h3 className="font-bold text-slate-800 flex items-center gap-2"><History className="w-4 h-4 text-emerald-500"/> Thu nhập (Nạp)</h3>
                    </div>
                    <div className="max-h-[500px] overflow-y-auto">
                        <table className="w-full text-xs text-left">
                            <thead className="bg-slate-50 text-slate-500 uppercase font-bold sticky top-0">
                                <tr>
                                    <th className="px-4 py-3">Khách hàng</th>
                                    <th className="px-4 py-3">Ngày</th>
                                    <th className="px-4 py-3 text-right">Số tiền</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-slate-50">
                                {filteredTxns.map(t => (
                                    <tr key={t.id} className="hover:bg-slate-50">
                                        <td className="px-4 py-3 font-bold">{t.customerName}</td>
                                        <td className="px-4 py-3 text-slate-400">{t.date}</td>
                                        <td className="px-4 py-3 text-right font-black text-emerald-600">${t.amount}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="bg-white rounded-xl shadow-sm border border-slate-200">
                    <div className="p-4 border-b border-slate-100 flex justify-between items-center">
                        <h3 className="font-bold text-slate-800 flex items-center gap-2"><Wallet className="w-4 h-4 text-red-500"/> Chi trả (Rút)</h3>
                    </div>
                    <div className="max-h-[500px] overflow-y-auto">
                        <table className="w-full text-xs text-left">
                            <thead className="bg-slate-50 text-slate-500 uppercase font-bold sticky top-0">
                                <tr>
                                    <th className="px-4 py-3">Affiliate</th>
                                    <th className="px-4 py-3">Ngày</th>
                                    <th className="px-4 py-3 text-right">Số tiền</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-slate-50">
                                {filteredPayouts.map(p => (
                                    <tr key={p.id} className="hover:bg-slate-50">
                                        <td className="px-4 py-3 font-bold">{p.affiliateName}</td>
                                        <td className="px-4 py-3 text-slate-400">{p.date}</td>
                                        <td className="px-4 py-3 text-right font-black text-red-600">-${p.amount}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};
